import { useEffect, useState, useCallback } from "react";
import axiosInstance from "../../apiInstances/axiosInstance";
import agency4 from "../../assets/agency-4.png";
import agent2 from "../../assets/agent-2.png";
import { normalizePropertyList } from "../../utils/normalizePropertyList";

export function useGetAllListings(status = "Active") {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const fetchAll = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axiosInstance.post("Agency/viewAllProperty", {
        status,
        userId: userData?.id || null,
      });

      if (!res?.data?.status) {
        throw new Error(res?.data?.message || "Failed to fetch data");
      }

      const mydata = res?.data?.data || [];

      const enriched = mydata.map((obj) => ({
        ...obj,
        agencyImg: agency4,
        agentImg: agent2,
      }));

      const normalized = normalizePropertyList(enriched);

      setData(normalized);
      return normalized;
    } catch (e) {
      setError(e);
      setData([]);
      throw e;
    } finally {
      setLoading(false);
    }
  }, [status]);

  // useEffect(() => {
  //   fetchAll();
  // }, [fetchAll]);

  return { data, loading, error, refetch: fetchAll, setData };
}
